
<head>
    <title>{{title}}</title>
</head>
<router-outlet />